import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=208c5b75&"
import script from "./Tour.vue?vue&type=script&lang=ts&"
export * from "./Tour.vue?vue&type=script&lang=ts&"
import style0 from "./Tour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
